<template>
  <v-chip :color="color[status]" small>
    {{ status }}
  </v-chip>
</template>

<script>
export default {
  props: ["status"],
  data() {
    return {
      color: {
        open: "amber lighten-3",
        scheduled: "green lighten-3",
        closed: "red lighten-3",
        cancelled: null,
      },
    };
  },
};
</script>
